import React from 'react'
import './Footer.css'

interface FooterProps {}

const Footer: React.FC<FooterProps> = () => {
  return (
    <footer className="footer">
      <p className="footer__main">
        This Site Was Made With ❤ By <a href="http://farnamh.ir">Farnam</a>
      </p>
      <p className="footer__git">
        <a href="https://github.com/homfarnam/Covid-19-tracker">
          Github Repository
        </a>
      </p>
    </footer>
  )
}

export default Footer
